import { MobiDocument } from './MobiDocument';
import { PointageDetailInoeDocument } from './PointageDetailInoeDocument';
import { Individu } from './Individu';
import { Inscription } from './Inscription';
import { SupplementPointageDocument } from './SupplementPointageDocument';

export class PointageInoeDocument extends MobiDocument {
    private _id: string;
    private _rev: string;
    private id: number;
    private date: string;
    private type: string;
    private schedulable_id: number;

    //Attributs for Vuejs
    private individu_id: number;

    public constructor(pointageinoe: any) {
        super()
        this._id = pointageinoe._id;
        this._rev = pointageinoe._rev;
        this.id = pointageinoe.id;
        this.date = pointageinoe.date;
        this.type = pointageinoe.type;
        this.schedulable_id = pointageinoe.schedulable_id;
        this.individu_id = -1;
    }

    public get_id(): string {
        return this._id;
    }

    public set_id(_id: string): void {
        this._id = _id;
    }

    public get_rev(): string {
        return this._rev;
    }

    public set_rev(_rev: string): void {
        this._rev = _rev;
    }

    public getId(): number {
        return this.id;
    }

    public setId(id: number): void {
        this.id = id;
    }

    public getDate(): string {
        return this.date;
    }

    public setDate(date: string): void {
        this.date = date;
    }

    public getType(): string {
        return this.type;
    }

    public setType(type: string): void {
        this.type = type;
    }

    public getSchedulable_id(): number {
        return this.schedulable_id;
    }

    public setSchedulable_id(schedulable_id: number): void {
        this.schedulable_id = schedulable_id;
    }

    public getIndividu_id(): number {
        return this.individu_id;
    }

    public setIndividu_id(individu_id: number): void {
        this.individu_id = individu_id;
    }


    public getPointagesDetails(): Array<PointageDetailInoeDocument> {
        return this.memdb.find({
            doctype: "PointageDetailDocument",
            fkey: "pointage_id",
            fvalue: this.id
        });
    }

    public getSupplementPointage(): Array<SupplementPointageDocument> {
        return this.memdb.find({
            doctype: "SupplementPointageDocument",
            fkey: "pointage_id",
            fvalue: this.id
        });
    }
    public getIndividu(): Individu {
        let inscription: Inscription = this.memdb.findOne({
            doctype: "InscriptionDocument",
            fkey: "id",
            fvalue: this.schedulable_id
        }, false)
        return inscription.getIndividu();
    }

}